import { render, staticRenderFns } from "./OpPrimarySelection.vue?vue&type=template&id=f1ac1292&"
import script from "./OpPrimarySelection.vue?vue&type=script&lang=js&"
export * from "./OpPrimarySelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports